export const getLookupCodeValue = (templateCode?: string) => `valueLists/DRILL_DOWN?sublistCode=${templateCode}`;
